<template>
  <div
    v-if="updateDetails.actionTypeId == billActionTypeEnum.refundDone"
    class="attribute-item-row"
  >
    <div class="attribute-item py-3">
      <div class="attribute-item-title">
        {{ local.judicialFees.billRefundDetails.amount }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ updateDetails.amount }}
      </div>
    </div>

    <div class="attribute-item py-3">
      <div class="attribute-item-title">
        {{ local.judicialFees.billRefundDetails.refundedAmount }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ updateDetails.refundedAmount }}
      </div>
    </div>

    <div class="attribute-item py-3">
      <div class="attribute-item-title">
        {{ local.judicialFees.billRefundDetails.refundedDate }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ toHijriDate(updateDetails.updatedDate) }}
      </div>
    </div>
  </div>
  <div
    v-else-if="updateDetails.actionTypeId == billActionTypeEnum.confirmUpdateInvoice"
    class="attribute-item-row"
  >
    <div class="attribute-item py-3">
      <div class="attribute-item-title">
        {{ local.judicialFees.billUpdateDetails.originalAmount }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ updateDetails.legacyBillAmount }}
      </div>
    </div>

    <div class="attribute-item py-3">
      <div class="attribute-item-title">
        {{ local.judicialFees.billUpdateDetails.currentAmount }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ updateDetails.amount }}
      </div>
    </div>

    <div class="attribute-item py-3">
      <div class="attribute-item-title">
        {{ local.judicialFees.billUpdateDetails.updateDate }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ toHijriDate(updateDetails.updatedDate) }}
      </div>
    </div>
  </div>
</template>

<script>
import { toHijriDate } from '@/helpers/utils';
import { billActionType as billActionTypeEnum } from '@/helpers/enum';

export default {
  name: 'BillUpdateDetails',
  components: {},
  props: {
    updateDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toHijriDate,
      billActionTypeEnum,
    };
  },
  computed: {},
  watch: {},
  mounted() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

    .attribute-item-title {
        font-size: 14px;
        font-weight: bold;
        color: var(--app-primary-color);
    }

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: var(--app-dark-primary-color);
}
</style>
